import React from 'react'
import Link from 'gatsby-link'
import profile from './tom.jpg'

const Profile = () => 
  <img className="img-fluid rounded-circle" src={profile} />

export default Profile



// WEBPACK FOOTER //
// ./src/components/profile/profile.js